import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface PropertyDescriptionModel extends BaseModel {
  variables?: { [key: string]: string } | PropertyDescriptionVariables;
}

export interface PropertyDescriptionVariables {
  PropertyDescImageDesktop: string;
  PropertyDescImageMobile: string;
  PropertyDescImageHref: string;
  PropertyDescImageAlt: string;
  PropertyDescPropertyName: string;
  PropertyDescription: string;
  PropertyDescCtaLink: string;
  PropertyDescCtaText: string;
  PropertyDescImageHrefSegmentRegex: string;
  PropertyDescCtaLinkSegmentRegex: string;
}

export class PropertyDescriptionInitVariables implements PropertyDescriptionVariables {
  PropertyDescImageDesktop = '';
  PropertyDescImageMobile = '';
  PropertyDescImageHref = '';
  PropertyDescImageAlt = '';
  PropertyDescPropertyName = '';
  PropertyDescription = '';
  PropertyDescCtaLink = '';
  PropertyDescCtaText = '';
  PropertyDescImageHrefSegmentRegex = '';
  PropertyDescCtaLinkSegmentRegex = '';
}

export class PropertyDescriptionInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new PropertyDescriptionInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
